import { Link } from 'react-router-dom'
import SEO from '@/components/seo/SEO'

/**
 * 404 amigable con CTA volver home — D3 stub.
 * SEO D10: noindex (no indexar páginas de error).
 */
export default function NotFound() {
  return (
    <>
      <SEO
        title="Página no encontrada — FITLAB"
        description="La página que buscas no existe o fue movida. Vuelve al inicio para seguir explorando FITLAB."
        noindex
      />
      <div className="mx-auto flex min-h-[70vh] max-w-2xl flex-col items-center justify-center px-4 py-24 text-center sm:px-6">
        <p className="text-fitlab-gradient text-7xl font-bold tracking-tight sm:text-9xl">404</p>
        <h1 className="mt-6 text-3xl font-bold tracking-tight text-fitlab-neutral-900 sm:text-4xl">
          Página no encontrada
        </h1>
        <p className="mt-4 max-w-md text-base leading-relaxed text-fitlab-neutral-600">
          La ruta que buscas no existe o fue movida. Revisa la URL o vuelve al inicio.
        </p>
        <Link
          to="/"
          className="mt-10 inline-flex items-center gap-2 rounded-full bg-fitlab-blue px-7 py-3 text-sm font-semibold text-white shadow-sm transition-all hover:-translate-y-0.5 hover:bg-fitlab-blue-hover hover:shadow-md"
        >
          Volver al inicio
          <span aria-hidden="true">→</span>
        </Link>
      </div>
    </>
  )
}
